import { Declaration } from 'store/declarations/declaration';
import { getDeclarationItems } from 'views/declarations/utils/declaration-utils';
import { ErrorFieldContext } from './resolveErrorField';

/**
 * Where a customs error's item positions are read: the items as they were submitted and as they are
 * today. The products table counts and the error cards both start from here, so they always name
 * the same item.
 *
 * The declaration's own items carry the ids the products table keys its rows by - the form's copy of
 * a CDS item does not. Without an item path there is nothing to read, and no context.
 */
const getErrorFieldContext = (
    declaration: Declaration | undefined,
    itemPath: string | undefined,
    submittedDeclaration: Declaration | undefined
): Omit<ErrorFieldContext, 'firstNumber'> | undefined => {
    const itemSegment = itemPath?.split('.').at(-1);
    if (!itemSegment) return undefined;

    return {
        itemSegment,
        submittedItems: submittedDeclaration ? getDeclarationItems(submittedDeclaration) ?? [] : undefined,
        currentItems: getDeclarationItems(declaration) ?? [],
    };
};

export default getErrorFieldContext;
